/* Copyright (c) 2018 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
    angular.module('com.vmware.vsphere.client.commonModule')
        .factory('RemoveMultiTagsGridFactory', RemoveMultiTagsGridFactory);

    RemoveMultiTagsGridFactory.$inject = ['$rootScope', 'tagService', 'i18nService', 'vuiConstants'];

    function RemoveMultiTagsGridFactory($rootScope, tagService, i18nService, vuiConstants) {

        function MultiTagGrid(objectIds) {
            var self = this;
            self.objectIds = objectIds;

            self.datagridOptions = {
                columnDefs: [
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.assignedNameColumn'),
                        field: 'name',
                        sortable: false,
                        searchable: false
                    },
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.categoryColumn'),
                        field: 'categoryName',
                        sortable: false,
                        searchable: false
                    },
                    {
                        displayName: i18nService.getString('Common', 'tag.dashboard.descColumn'),
                        field: 'description',
                        sortable: false,
                        searchable: false
                    }
                ],
                height: '200px',
                resizable: false,
                reorderable: false,
                selectedItems: [],
                selectionMode: vuiConstants.grid.selectionMode.MULTI,
                showCheckboxesOnMultiSelection: false,
                selectedTags: [],
                data: []
            };

            $rootScope.$on('tagUpdate', function (event, changedObjectId) {
                if (self.objectIds.indexOf(changedObjectId) !== -1) {
                    self.populateDataGrid();
                }
            });
        }

        MultiTagGrid.prototype.populateDataGrid = function () {
            var self = this;
            self.objectIds.forEach(function (objectId) {
                tagService.getTagInfoForObject(objectId).then(function (tagData) {
                    var newArrival = tagData.filter(function (arrived) {
                        return !self.datagridOptions.data.some(function (item) {
                            return _.isEqual(arrived, item);
                        });
                    });
                    self.datagridOptions.data = self.datagridOptions.data.concat(newArrival);
                });
            });
        };

        MultiTagGrid.prototype.removeTag = function () {
            var self = this;
            var numOfSelectedTags = self.datagridOptions.selectedItems.length;
            var lastTagInTheList = self.datagridOptions.selectedItems[numOfSelectedTags - 1];
            for (var tag = 0; tag < numOfSelectedTags - 1; tag++) {
                this.removeMultiple(self.objectIds, self.datagridOptions.selectedItems[tag]);
            }
            if (lastTagInTheList) {
                this.removeMultiple(self.objectIds, lastTagInTheList, true);
            }
        };

        MultiTagGrid.prototype.removeMultiple = function (objectIds, selectedTag, shouldSendUpdate) {
            objectIds.forEach(function (objectId) {
                tagService.detachTag(selectedTag.resourceObject, objectId).then(function () {
                    if (shouldSendUpdate) {
                        $rootScope.$broadcast('tagUpdate', objectId);
                    }
                });
            });
        };

        MultiTagGrid.prototype.setTagSelectionListener = function (tagSelectionListener) {
            var self = this;
            $rootScope.$watch(
                function () {
                    return self.datagridOptions.selectedItems;
                },
                function (selectedItems) {
                    var selectedTagsInPortlet = (selectedItems && selectedItems.length) ? selectedItems : null;
                    tagSelectionListener.call(this, selectedTagsInPortlet);
                }
            );
        };

        MultiTagGrid.prototype.refresh = function () {
            this.populateDataGrid();
        };

        function make(objectIds) {
            return new MultiTagGrid(objectIds);
        }

        return {
            make: make
        };
    }
}());